export default __webpack_public_path__ + "static/media/bg-pattern-detail-footer.439c5055.svg";